module.exports = require('./helpers/bundle-url').getBundleURL('hyeyu') + "../pin.17ac4448.svg";